module.exports = __webpack_public_path__ + "img/radius-bottomleft.3c44f2ab.svg";